export default __webpack_public_path__ + "static/media/Dario Martinez.9846163f.jpg";